


















































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName, getIndexFromList, excludeIdFromList, getListWithNewItem } from '../../core/utils';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { NormsServices } from '../api/NormsServices';
import CreateEcuDialog from '../components/CreateEcuDialog.vue';
import { generateZipFile } from '../index';
import { time } from 'highcharts';
import { timeout } from 'rxjs/operators';
import { PageTitle } from '../../core/components';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 

@Component({
    components: { CreateEcuDialog, PageTitle, DeleteConfirmation, Input, SimpleTable }
})
export default class NormasEcusList extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper) {
    sortBy: string[] = ['id'];
    sortDesc: boolean[] = [true];
    loadingPreviewData: boolean = false;
    previewEcuFromList: boolean = false;
    previewEcuFromListData: object = {};
    showModalCreateEcu: boolean = false;
    ecuToDelete: number = -1;
    pendingRequest: boolean = false;
    pendingRequestFilterOptions: boolean = false;
    showDeleteConfirmationDialog: boolean = false;
    deleteConfirmationTitle: string = 'Eliminar ECU';
    deleteConfirmationMessage: string = '¿Está seguro que desea eliminar esta ECU? Ésta acción no se podrá deshacer.';
    search: string = '';
    headers: any[] = [
        {
            text: 'ID',
            align: 'center',
            value: 'id'
        },
        {
            text: 'Descripción privada',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Descripción pública',
            align: 'left',
            value: 'public_description'
        },
        {
            text: 'ECURdAddr',
            align: 'center',
            value: 'ECURdAddr'
        },
        {
            text: 'Protocolo',
            align: 'left',
            value: 'protocol'
        },
        {
            text: 'Normas presente',
            align: 'center',
            value: 'active_files',
            width: '200'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            sortable: false,
            width: '250px'
        }
    ];
    items: any = [];
    pagination: object = {
        rowsPerPageItems: 18
    };
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    mounted() {
        this.getEcusList();
    }

    updateSearchValue(value){
        this.search = value;
    }

    trucate(value, length = 200) {
        return value.length <= length ? value : value.substring(0, length) + '...';
    }

    getEcusList() {
        this.pendingRequest = true;
        NormsServices.getEcusList(Axios.CancelToken.source())
            .then(response => {
                this.items = response.map(function(item){
                    return {
                        ...item,
                        disableDelete: item['active_files'] > 0 ? true : false
                    }
                });
                this.pendingRequest = false;
            })
            .catch(error => {
                this.pendingRequest = false;
            });
    }

    createNewEcu() {
        this.previewEcuFromListData = {};
        this.modalCreateEcuVisibility(true);
    }

    previewEcu(item, isPreviewing: boolean, loadingKey?:string) {
        // this.loadingPreviewData = true;
        let ecuId = item['id'];
        let loadingKei = loadingKey ? loadingKey : 'isLoading';
        this.$set(item, loadingKei, true);
        this.previewEcuFromListData = {};

        NormsServices.getEcuData(ecuId)
            .then(response => {
                this.previewEcuFromList = isPreviewing;
                let previewData = response['ecu'];
                previewData['id'] = ecuId;
                this.previewEcuFromListData = previewData;
                this.modalCreateEcuVisibility(true);
                this.$set(item, loadingKei, false);
                // this.loadingPreviewData = false;
            })
            .catch(error => {
                this.previewEcuFromList = false;
                this.previewEcuFromListData = {};
                this.$set(item, loadingKei, false);
                //    this.loadingPreviewData = false;
            });

        // this.previewEcuFromListData = {};
    }

    createFileFromThis(item) {
        this.previewEcu(item, false, 'createFromThis');
    }

    modalCreateEcuVisibility(value) {
        this.showModalCreateEcu = value;

        if (!value) {
            this.previewEcuFromList = false;
            this.previewEcuFromListData = {};
        }
    }

    backToNormas() {
        this.$router.push(NAME_ROUTES.NORMAS.path);
    }

    addNewEcu(newEcu) {
        this.pendingRequest = true;
        this.items = getListWithNewItem(this.items, newEcu);
        this.pendingRequest = false;
    }

    modifyEcu(updatedEcu) {
        this.pendingRequest = true;
        // this.items.push(newEcu);
        let allItems = this.items;
        this.items = [];
        this.items = allItems;

        let indexEcuToUpdate = getIndexFromList(this.items, 'id', updatedEcu['id']);

        if (indexEcuToUpdate !== -1) {
            this.$set(this.items[indexEcuToUpdate], 'description', updatedEcu['description']);
            this.$set(this.items[indexEcuToUpdate], 'protocol', updatedEcu['protocol']);
            this.$set(this.items[indexEcuToUpdate], 'public_description', updatedEcu['public_description']);
            this.$set(this.items[indexEcuToUpdate], 'active_files', updatedEcu['active_files']);
            this.$set(this.items[indexEcuToUpdate], 'ECURdAddr', updatedEcu['ECURdAddr']);
        }
        setTimeout(() => {
            this.pendingRequest = false;
        }, 200);
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    deleteECU(item) {
        this.deleteModalTitle = 'Eliminar ECU';
        this.deleteBody = '¿Está seguro que desea eliminar la ECU ' + '<b>"' + item['description'] + '"</b>?';
        this.ecuToDelete = Number(item['id']);
        this.confirmationDelete = true;
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.pendingRequest = true;
            this.deleteEcuAction();
        } else {
            this.confirmationDelete = false;
            this.ecuToDelete = -1;
        }
    }

    deleteEcuAction() {
        let self = this;
        if (this.ecuToDelete !== -1) {
            NormsServices.deleteECUById(self.ecuToDelete)
                .then(response => {
                    this.items = excludeIdFromList(this.items,  self.ecuToDelete);
                    if (response && response.data && response.data.message) {
                        self.$_successDeleteRecipients(response['data']['message']);
                    } else {
                        self.$_successDeleteRecipients('ECU eliminada con éxito');
                    }
                    let allItems = self.items;
                    self.items = [];

                    setTimeout(() => {
                        self.pendingRequest = false;
                        self.items = allItems;
                        self.ecuToDelete = -1;
                    }, 500);
                })
                .catch(error => {
                    if (error && error.response && error.response.data && error.response.data.message) {
                        self.$_errorPatchRecipients(error.response.data.message);
                    } else {
                        self.$_errorPatchRecipients('No se pudo eliminar la ECU');
                    }
                    self.ecuToDelete = -1;
                    self.pendingRequest = false;
                });
        }
    }
}
